
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import { handleKeyDown } from '../../../util/utils'

class ProcessingAgencyModal extends PureComponent {
  constructor () {
    super()
    this.state = {
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      return {
        agency: { ...this.props.agency }
      }
    }
    return null
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (snapshot) {
      this.props.initialize(snapshot.agency)
    }
  }

  submitAgency (values) {
    const body = {
      ...values
    }
    this.props.actions.submitProcessingAgency(body, this.props.agency)
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      combos: { UOTreeCombo }
    } = this.props
    const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.MODAL.'
    return (
      <Modal id="processingAgencyMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeEditProcessingAgencyModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitAgency.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeEditProcessingAgencyModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
              />
              <Field
                component={InputTreeSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                multi={false}
                allowClear={false}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                colSm={0}
                options={UOTreeCombo}
                // validate={[this.required]}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="collegiateMemberNumber"
                controlLabel={t(`${tKey}COLLEGIATE_MEMBER_NUMBER`)}
                placeholder={t(`${tKey}COLLEGIATE_MEMBER_NUMBER`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="city"
                controlLabel={t(`${tKey}CITY`)}
                placeholder={t(`${tKey}CITY`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="address"
                controlLabel={t(`${tKey}ADDRESS`)}
                placeholder={t(`${tKey}ADDRESS`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="postCode"
                controlLabel={t(`${tKey}POSTAL_CODE`)}
                placeholder={t(`${tKey}POSTAL_CODE`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="representativeName"
                controlLabel={t(`${tKey}REPRESENTATIVE_NAME`)}
                placeholder={t(`${tKey}REPRESENTATIVE_NAME`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="addressNumber"
                controlLabel={t(`${tKey}ADDRESS_NUMBER`)}
                placeholder={t(`${tKey}ADDRESS_NUMBER`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="representativeCifNif"
                controlLabel={t(`${tKey}REPRESENTATIVE_CIF_NIF`)}
                placeholder={t(`${tKey}REPRESENTATIVE_CIF_NIF`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="associationProvince"
                controlLabel={t(`${tKey}ASSOCIATION_PROVINCE`)}
                placeholder={t(`${tKey}ASSOCIATION_PROVINCE`)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'processingAgencyMasterModal',
  validate: (values, props) => {
    const error = { }
    if (values) {
      const tKey = 'MASTERS.PROCESSING_AGENCY_MASTERS.VALIDATION.'
      if (!values.name) {
        error.name = props.t(`${tKey}NAME`)
      }
      if (!values.organizedUnitId) {
        error.organizedUnitId = props.t(`${tKey}ORGANIZED_UNIT`)
      }
      if (!values.collegiateMemberNumber) {
        error.collegiateMemberNumber = props.t(`${tKey}COLLEGIATE_MEMBER_NUMBER`)
      }
      if (!values.city) {
        error.city = props.t(`${tKey}CITY`)
      }
      if (!values.address) {
        error.address = props.t(`${tKey}ADDRESS`)
      }
      if (!values.postCode) {
        error.postCode = props.t(`${tKey}POSTAL_CODE`)
      }
      if (!values.representativeName) {
        error.representativeName = props.t(`${tKey}REPRESENTATIVE_NAME`)
      }
      if (!values.addressNumber) {
        error.addressNumber = props.t(`${tKey}ADDRESS_NUMBER`)
      }
      if (!values.representativeCifNif) {
        error.representativeCifNif = props.t(`${tKey}REPRESENTATIVE_CIF_NIF`)
      }
      if (!values.associationProvince) {
        error.associationProvince = props.t(`${tKey}ASSOCIATION_PROVINCE`)
      }
    }

    return error
  }
})(ProcessingAgencyModal)
